import { ApplicationState } from "../../ApplicationState";

export const forgotPasswordConfirmedSelector = (state: ApplicationState): boolean | undefined => {
    return state.globals.passwordReset.isForgotConfirmed;
}

export const resetPasswordConfirmedSelector = (state: ApplicationState): boolean | undefined => {
    return state.globals.passwordReset.isResetConfirmed;
}